export default __webpack_public_path__ + "static/media/Strawberry-Cheesecake.6e471552.jpg";